{
 "male": [
  "Arjhan",
  "Balasar",
  "Medrash",
  "Torinn",
  "Rhogar",
  "Kriv",
  "Daar",
  "Bharash",
  "Donaar",
  "Ghesh",
  "Heskan",
  "Mehen",
  "Pandjed",
  "Patrin",
  "Shamash",
  "Shedinn",
  "Krosis",
  "Nahagliiv",
  "Adrazar",
  "Akhorrash",
  "Alazhar",
  "Arakhor",
  "Arrash",
  "Azhurak",
  "Bakhtar",
  "Baradash",
  "Barrok",
  "Belgarrax",
  "Bhazrak",
  "Borashk",
  "Bryxan",
  "Darrakh",
  "Dazhar",
  "Dhorvash",
  "Drakhun",
  "Druumath",
  "Ezrakh",
  "Ghardrak",
  "Grakhul",
  "Hakhar",
  "Harzhan",
  "Hazhrim",
  "Ikarrus",
  "Jhaedar",
  "Jharvesh",
  "Jorrak",
  "Kaltharr",
  "Kethrax",
  "Khazrun",
  "Kurrath",
  "Lorkhaan",
  "Makhran",
  "Marrok",
  "Meshkar",
  "Morvaxx",
  "Mozhar",
  "Naazhar",
  "Nadrahk",
  "Narkhul",
  "Nazgar",
  "Okhrain",
  "Rhuvex",
  "Ruuzhar",
  "Sarrakh",
  "Sharak",
  "Shezhar",
  "Skarrith",
  "Surrok",
  "Tarkhos",
  "Tharzim",
  "Torrahk",
  "Uldraak",
  "Vakhor",
  "Vazhrin",
  "Vharuun",
  "Vurrakh",
  "Xarrok",
  "Yarzhak",
  "Zarkhul",
  "Zhakar",
  "Ardhan",
  "Bakhrim",
  "Ghaarn",
  "Jhazrin",
  "Kharvos",
  "Pyrrhax",
  "Raakhul",
  "Talkhor",
  "Wyrrax",
  "Ystravar",
  "Aggrath",
  "Barzhul",
  "Coryth",
  "Draavus",
  "Galdhrun",
  "Gharim",
  "Haakon",
  "Hazgar",
  "Irrkhan",
  "Jaskar",
  "Kharim",
  "Korrinth",
  "Morrikh",
  "Nharrok",
  "Ormarr",
  "Pazhrek",
  "Tazhran",
  "Thalmar",
  "Turrok",
  "Vaskhor",
  "Zakhrim",
  "Ashkarr",
  "Darrvan",
  "Dravosh",
  "Ekhran",
  "Halvorr",
  "Maarkhul",
  "Rhazvan",
  "Torvhal",
  "Akmaar",
  "Bhorrin",
  "Draxxor",
  "Eshvaar",
  "Ithrakk",
  "Mazrikh",
  "Pyrrok",
  "Tharrikh",
  "Brakhus",
  "Daurvos",
  "Kaazrin",
  "Ashtarrh",
  "Hralvek",
  "Yshkar",
  "Naskar",
  "Sharvok",
  "Zhurvan",
  "Dhakkar",
  "Raavok",
  "Kalthor",
  "Drovak",
  "Hrazvek",
  "Adrex",
  "Baradad",
  "Bidreked",
  "Dadalan",
  "Direcris",
  "Gargax",
  "Greethen",
  "Hirrathak",
  "Ildrex",
  "Kaladan",
  "Kerkad",
  "Kiirith",
  "Mozikth",
  "Mreksh",
  "Nykkan",
  "Quarethon",
  "Rathkran",
  "Rivaan",
  "Trynnicus",
  "Vrondiss",
  "Zedaar",
  "Ardex",
  "Belvenn",
  "Corvex",
  "Dovahn",
  "Drennic",
  "Eldrex",
  "Fendrik",
  "Halvex",
  "Hethrim",
  "Idrimm",
  "Iskel",
  "Kelvoth",
  "Kethren",
  "Korbek",
  "Ludrek",
  "Mardek",
  "Nalvek",
  "Nhorvex",
  "Oblek",
  "Pelleth",
  "Pendrik",
  "Quovan",
  "Remmeth",
  "Rethik",
  "Sathren",
  "Shennek",
  "Sorbek",
  "Ulmek",
  "Vandrex",
  "Veddek",
  "Velkor",
  "Vethis",
  "Yeddek",
  "Zemmek",
  "Corrum",
  "Daskum",
  "Gallum",
  "Hendrax",
  "Jeddum",
  "Kalloth",
  "Lothrum",
  "Moltrex",
  "Nebrim",
  "Perrex",
  "Quellum",
  "Rhinnex",
  "Sottrum",
  "Tolbek",
  "Ubrinn",
  "Vintrex",
  "Wedrik",
  "Xalbek",
  "Arkhenus",
  "Baltheron",
  "Calluvex",
  "Dravinus",
  "Eskanor",
  "Ghalvorn",
  "Hestrovan",
  "Imbraxus",
  "Kelvaxis",
  "Morduin",
  "Nazereth",
  "Orvantis",
  "Pyranthus",
  "Rhovanox",
  "Sithrennon",
  "Thurivax",
  "Xyrandos",
  "Zarthenor",
  "Belkan",
  "Dethek",
  "Ghorn",
  "Hask",
  "Jurn",
  "Krell",
  "Mekk",
  "Nask",
  "Rusk",
  "Tesk",
  "Vosk",
  "Zhek",
  "Arkan",
  "Bremm",
  "Doskel",
  "Gurm",
  "Hethek",
  "Ixen",
  "Jorn",
  "Kesh",
  "Nemmon",
  "Orgel",
  "Pazzik",
  "Rethmar",
  "Sedran",
  "Tolvar",
  "Urmek",
  "Bolgren",
  "Cindrex",
  "Dommeth",
  "Ervik",
  "Ferrun",
  "Hulvaan",
  "Jhaldren",
  "Kasmir",
  "Lurrik",
  "Meddon",
  "Nossek",
  "Ombreth",
  "Prennik",
  "Quorrun",
  "Ruddek",
  "Sabbeth",
  "Tummek",
  "Ussar",
  "Vellek",
  "Xerrik",
  "Yammek",
  "Zubek",
  "Aldreth",
  "Brannok",
  "Cethris",
  "Dumnor",
  "Esseth",
  "Fulgrim",
  "Gennek",
  "Haddon",
  "Ivrek",
  "Juveth",
  "Kollum",
  "Pethrek",
  "Rodrik",
  "Sennek",
  "Thovin",
  "Vargun",
  "Wendrik",
  "Ylvek",
  "Zostrum"
 ],
 "female": [
  "Kava",
  "Sora",
  "Harann",
  "Biri",
  "Thava",
  "Surina",
  "Nadarr",
  "Akra",
  "Farideh",
  "Havilar",
  "Jheri",
  "Korinn",
  "Mishann",
  "Nala",
  "Perra",
  "Raiann",
  "Uadjit",
  "Aashira",
  "Akhira",
  "Alazhra",
  "Ammeth",
  "Anzhira",
  "Ariveth",
  "Arrinna",
  "Ashenna",
  "Azhara",
  "Barrith",
  "Bazhira",
  "Belshira",
  "Brinnath",
  "Charrith",
  "Daarith",
  "Dahlira",
  "Darrinna",
  "Dhessa",
  "Drakkira",
  "Draveth",
  "Eshana",
  "Esvara",
  "Ezhira",
  "Faariss",
  "Fennath",
  "Ghessa",
  "Haalith",
  "Hazhira",
  "Hessith",
  "Ilvara",
  "Imrisha",
  "Isharra",
  "Jhanna",
  "Kaaliss",
  "Karrina",
  "Kharessa",
  "Kirrith",
  "Laazhra",
  "Lirrith",
  "Lorvanna",
  "Maarith",
  "Meshirra",
  "Morvessa",
  "Naazhra",
  "Narrith",
  "Nessara",
  "Orrisha",
  "Oshanna",
  "Qirrava",
  "Raazhra",
  "Rheshana",
  "Rivessa",
  "Sarrinna",
  "Shaazha",
  "Shennath",
  "Shirrava",
  "Sivarra",
  "Suleth",
  "Thessaly",
  "Tovarra",
  "Ulvessa",
  "Urrisha",
  "Uzhanna",
  "Varrinna",
  "Vezhra",
  "Vharessa",
  "Yrrissa",
  "Zarrina",
  "Zuvarra",
  "Aaravi",
  "Ivashra",
  "Kalessa",
  "Marrisha",
  "Orveth",
  "Sazhra",
  "Arrova",
  "Ashveth",
  "Baleshra",
  "Dovarra",
  "Fazhra",
  "Ilzhara",
  "Kaarna",
  "Neshara",
  "Orrava",
  "Rinnath",
  "Tirra",
  "Yshara",
  "Bhazra",
  "Erravi",
  "Harrova",
  "Izzara",
  "Mirrova",
  "Ozhara",
  "Thirrava",
  "Davarra",
  "Frisshi",
  "Irrova",
  "Raveth",
  "Thazra",
  "Barrova",
  "Lirrava",
  "Nirrava",
  "Shaleth",
  "Zaveth",
  "Sharrova",
  "Torrisha",
  "Zirrova",
  "Garrova",
  "Hirrova",
  "Lhazra",
  "Arava",
  "Burana",
  "Chassath",
  "Dentratha",
  "Doudra",
  "Driindar",
  "Eggren",
  "Findex",
  "Furrele",
  "Gesrethe",
  "Gilkass",
  "Hethress",
  "Hillanot",
  "Jaxi",
  "Jezean",
  "Kadana",
  "Megren",
  "Pogranix",
  "Pyxrin",
  "Quespa",
  "Rezena",
  "Ruloth",
  "Savaran",
  "Synthrin",
  "Tatyan",
  "Vezera",
  "Zykroff",
  "Ambrel",
  "Calvi",
  "Elgren",
  "Hanniv",
  "Iolda",
  "Jessen",
  "Kelvi",
  "Lumra",
  "Mezzen",
  "Rozzi",
  "Seshen",
  "Tavi",
  "Ulma",
  "Vessi",
  "Wyndra",
  "Xessen",
  "Ysolra",
  "Zaffi",
  "Cimra",
  "Dazzen",
  "Embril",
  "Fennex",
  "Gaavi",
  "Hessel",
  "Ishni",
  "Lissan",
  "Myrrin",
  "Nezzi",
  "Pashti",
  "Silvex",
  "Vanthe",
  "Xaxi",
  "Yevi",
  "Zandi",
  "Bremmi",
  "Corva",
  "Dreeni",
  "Feyn",
  "Gilsa",
  "Hadri",
  "Lenne",
  "Mirsa",
  "Ondri",
  "Savra",
  "Zuri",
  "Abrisse",
  "Bezzen",
  "Elvexa",
  "Fethi",
  "Hulda",
  "Jessra",
  "Lanni",
  "Mevra",
  "Noxi",
  "Sitha",
  "Tessen",
  "Ulvi",
  "Vaxi",
  "Xandra",
  "Yessen",
  "Ardra",
  "Caxi",
  "Delvi",
  "Eskra",
  "Fanni",
  "Halvi",
  "Imra",
  "Keddi",
  "Mennix",
  "Novra",
  "Oski",
  "Rethi",
  "Sulvi",
  "Uxi",
  "Velmi",
  "Yonni",
  "Zekka",
  "Belys",
  "Coris",
  "Daelin",
  "Esmyr",
  "Faryn",
  "Gwenix",
  "Ilys",
  "Jenvys",
  "Kaelix",
  "Lyssel",
  "Orrel",
  "Pyrel",
  "Quilys",
  "Ravix",
  "Sennix",
  "Thyrel",
  "Ulys",
  "Vanyx",
  "Xyrel",
  "Yrsel",
  "Zennis",
  "Aldys",
  "Cerrin",
  "Dovyn",
  "Eshel",
  "Fintra",
  "Gessix",
  "Hallyn",
  "Isvel",
  "Jarys",
  "Lirel",
  "Mezzix",
  "Navyn",
  "Oralys",
  "Peshel",
  "Renvys",
  "Saelyn",
  "Tovys",
  "Uvel",
  "Vashyn",
  "Wrenix",
  "Yelvyn",
  "Zorys",
  "Aedre",
  "Corrane",
  "Ezhne",
  "Faelle",
  "Grisse",
  "Hethre",
  "Ilvane",
  "Korvane",
  "Morrane",
  "Nessane",
  "Ovesse",
  "Pyrine",
  "Qethe",
  "Ruvane",
  "Sorvane",
  "Uline",
  "Vexane",
  "Yvane",
  "Arrah",
  "Bezah",
  "Kethah",
  "Mirah",
  "Rennah",
  "Shazah",
  "Tavah",
  "Zirah"
 ],
 "family": [
  "Kerrhylon",
  "Myastan",
  "Daardendrian",
  "Yarjerit",
  "Turnuroth",
  "Norixius",
  "Kimbatuul",
  "Delmirev",
  "Drachedandion",
  "Kepeshkmolik",
  "Nemmonis",
  "Akambheryl",
  "Altheramyr",
  "Ammakhthal",
  "Andrathiel",
  "Arkhosian",
  "Baharoosh",
  "Belaerithax",
  "Bhazurathi",
  "Byrrhenath",
  "Calaxiar",
  "Cedrothian",
  "Cyrrhilax",
  "Daelmarrok",
  "Damarathis",
  "Dezzavaron",
  "Dhoraskhan",
  "Dravenhyrr",
  "Drolkathar",
  "Durrasmeth",
  "Eilthorvax",
  "Endrimmion",
  "Eshkaraval",
  "Essivarth",
  "Fendrathul",
  "Ghaldarrion",
  "Gharrumoth",
  "Grendvaal",
  "Gyrrhathon",
  "Haldrexian",
  "Hazurketh",
  "Hesperanth",
  "Hyskanderi",
  "Ildrathyr",
  "Imarrikon",
  "Irrikhatul",
  "Ishmeradon",
  "Jarrakhoth",
  "Jhestavaar",
  "Kaltharion",
  "Kavvarith",
  "Kesmerroth",
  "Khaarundel",
  "Kholmaraz",
  "Korvenhyrr",
  "Krannathos",
  "Kurtalvash",
  "Lazharoth",
  "Lethrimmon",
  "Lyskhandar",
  "Maazrimoth",
  "Malkovarr",
  "Mazurindel",
  "Merrexath",
  "Mordhaval",
  "Mythrenkar",
  "Naarvashel",
  "Nazrethion",
  "Nekhmarin",
  "Nurrivaxis",
  "Obrathiel",
  "Odrakkhan",
  "Olmarrix",
  "Orrhalveth",
  "Pazurinth",
  "Pyrrhimmon",
  "Qarrathul",
  "Quenthrivax",
  "Rhaazmeret",
  "Rhovandrim",
  "Rukhmeshar",
  "Saarvendil",
  "Sarrathion",
  "Shaakmorrn",
  "Shevarrith",
  "Skaardemon",
  "Sorrovesh",
  "Tazhmirrin",
  "Tharkevion",
  "Thessaranth",
  "Tirrovald",
  "Tormeshkar",
  "Ulmarrath",
  "Urraxendil",
  "Uthrovash",
  "Vaalkerith",
  "Vandrimmor",
  "Varrishtan",
  "Verthimyr",
  "Vhoskaran",
  "Vorrimeth",
  "Xarrovane",
  "Xendrakkis",
  "Yaazhuroth",
  "Yrrenthal",
  "Zaarkhemon",
  "Zarrivash",
  "Zemmerath",
  "Zhorvanteth",
  "Zorrakhaan",
  "Akvaris",
  "Bezmerit",
  "Calvarn",
  "Desmirak",
  "Ekkevan",
  "Fazhmir",
  "Gethiron",
  "Halkerim",
  "Ishtavan",
  "Jorumet",
  "Kalvesh",
  "Lemmorit",
  "Mazaran",
  "Nethrik",
  "Orvashen",
  "Paaskimir",
  "Querrinat",
  "Revasht",
  "Sorthemis",
  "Talmerev",
  "Uzzavan",
  "Vekkarit",
  "Ystamir",
  "Zolvenit",
  "Abbadrev",
  "Bharrimet",
  "Cezzamir",
  "Dolmeshan",
  "Esvarin",
  "Felkarith",
  "Gozzamir",
  "Hadrevan",
  "Ilkameth",
  "Jessivar",
  "Karrumet",
  "Lothmirev",
  "Merrivash",
  "Nostavan",
  "Omeshkar",
  "Pellavar",
  "Rhezmanit",
  "Serrakhan",
  "Tovenmir",
  "Ulmeshet",
  "Vorrakim",
  "Yzzevan",
  "Zethmirak",
  "Arnathul",
  "Bekkrosh",
  "Coldimar",
  "Draskevit",
  "Emmerath",
  "Furnavash",
  "Galmerith",
  "Hekkavor",
  "Imreshan",
  "Jalvemir",
  "Kezzavith",
  "Lurmandor",
  "Movrikan",
  "Nazzimet",
  "Osmerith",
  "Pethravan",
  "Ruskamir",
  "Shezzamir",
  "Thalvimet",
  "Unnarith",
  "Valmeshka",
  "Yrrimet",
  "Zannavik",
  "Emberscale",
  "Brightscale",
  "Copperwing",
  "Stormscale",
  "Flamecrest",
  "Goldhorn",
  "Ironscale",
  "Brasstalon",
  "Silverhorn",
  "Cinderwing",
  "Thunderhide",
  "Frostfang",
  "Bronzecrest",
  "Sunscale",
  "Duskhorn",
  "Embertail",
  "Ashwing",
  "Skyhorn",
  "Ironclaw",
  "Blackscale",
  "Redcrest",
  "Searfang",
  "Smokehorn",
  "Ashscale",
  "Moltenheart",
  "Flarewing",
  "Scorchtail",
  "Coalcrest",
  "Sparkscale",
  "Glowhorn",
  "Brazenfang",
  "Graniteclaw",
  "Stonetail",
  "Steelwing",
  "Highcrest",
  "Longtalon",
  "Broadwing",
  "Kingscale",
  "Dawnscale",
  "Starhorn",
  "Moonscale",
  "Nightwing",
  "Shadowscale",
  "Stormhorn",
  "Thunderscale",
  "Rainscale",
  "Tidehorn",
  "Seafang",
  "Saltscale",
  "Mistwing",
  "Fogcrest",
  "Icescale",
  "Rimeclaw",
  "Snowhorn",
  "Hailwing",
  "Sleetfang",
  "Galecrest",
  "Windscale",
  "Cloudhorn",
  "Skyfang",
  "Sunfang",
  "Goldwing",
  "Silverscale",
  "Copperclaw",
  "Brassheart",
  "Bronzetail",
  "Ironheart",
  "Steelheart",
  "Flameheart",
  "Fireheart",
  "Cinderhorn",
  "Smokewing",
  "Sootscale",
  "Kilnheart",
  "Forgescale",
  "Anvilclaw",
  "Hammerscale",
  "Shieldscale",
  "Wardhorn",
  "Oathscale",
  "Truthfang",
  "Honorcrest",
  "Valorwing",
  "Gloryhorn",
  "Proudcrest",
  "Wyrmblood",
  "Wyrmheart",
  "Wyrmcrest",
  "Drakeborn",
  "Drakehorn",
  "Drakefang",
  "Scaleborn",
  "Clawborn",
  "Hornbrand",
  "Flamebrand",
  "Sunbrand",
  "Starbrand",
  "Gemscale",
  "Jadecrest",
  "Rubyscale",
  "Sapphirehorn",
  "Onyxclaw",
  "Amberwing",
  "Garnetscale",
  "Opalhorn",
  "Quartzclaw",
  "Obsidianfang",
  "Basaltscale",
  "Cragscale",
  "Peakhorn",
  "Cliffwing",
  "Ridgeback",
  "Summitscale",
  "Arandek",
  "Balorgath",
  "Balorgiel",
  "Balulgan",
  "Bheimesh",
  "Bheorlyl",
  "Braikul",
  "Braonex",
  "Delanstyx",
  "Delardul",
  "Delovarr",
  "Draerkhar",
  "Draeshnur",
  "Drallavius",
  "Drarstath",
  "Durustul",
  "Durymvon",
  "Elamkhyx",
  "Elornan",
  "Eshadlax",
  "Eshimzhuul",
  "Eshirzek",
  "Eshudrorn",
  "Faladvorn",
  "Falaevax",
  "Falinthuul",
  "Falorbesh",
  "Ghalabeus",
  "Ghaluvum",
  "Goradryr",
  "Gorelmian",
  "Gorurdrath",
  "Griarmax",
  "Griastur",
  "Griedmyr",
  "Grienkheus",
  "Heserrok",
  "Hesimrik",
  "Hesinar",
  "Hesoshath",
  "Hesutuul",
  "Iramlat",
  "Irelsheth",
  "Irinvar",
  "Irulbath",
  "Ishozat",
  "Jharostix",
  "Jharixxis",
  "Kalexeus",
  "Kaulgiel",
  "Kauthir",
  "Kerulnyx",
  "Khorexok",
  "Khorinvath",
  "Khorokan",
  "Khorymthir",
  "Kimakdek",
  "Kimianoth",
  "Kimodar",
  "Kimorshir",
  "Kimulguul",
  "Kreethgar",
  "Kreulthek",
  "Larandryx",
  "Laringess",
  "Larizhix",
  "Lethatul",
  "Lethergir",
  "Maroxeth",
  "Mezadmir",
  "Mezanthum",
  "Mezorgar",
  "Myamxan",
  "Myartharr",
  "Myovdrax",
  "Naralstyx",
  "Narindrex",
  "Nemamvius",
  "Nemeltul",
  "Nemiasok",
  "Nemuniel",
  "Noredsith",
  "Norengar",
  "Norethvith",
  "Norovdius",
  "Omazhir",
  "Omurvyx",
  "Oreldrik",
  "Oromoth",
  "Ostelrath",
  "Ostiadur",
  "Ostorzaan",
  "Ostulrat",
  "Phyamvon",
  "Phyendreth",
  "Phyinius",
  "Quaradul",
  "Quaranmir",
  "Quariashan",
  "Rasathvath",
  "Rasimlir",
  "Rheakith",
  "Rhealbiel",
  "Rheeshgorn",
  "Sarakesh",
  "Saralstur",
  "Saredketh",
  "Sarobath",
  "Sarymkarr",
  "Shenimteth",
  "Shenelnax",
  "Sulandyr",
  "Sulibuul",
  "Sulustax",
  "Tarathbir",
  "Tarirstian",
  "Thalaldarr",
  "Thalurvarr",
  "Thalymrrath",
  "Torimxash",
  "Turathsyr",
  "Turirgix",
  "Turukhur",
  "Ulirvan",
  "Ularrir",
  "Vaeirul",
  "Vaeendan",
  "Varadresh",
  "Varaelan",
  "Varaknius",
  "Varandior",
  "Varendik",
  "Varudrex",
  "Veorthion",
  "Voradzhion",
  "Voraeziel",
  "Vorodyx",
  "Voreshkhorn",
  "Xanedthan",
  "Yaramtoth",
  "Yarenzond",
  "Yarorsion",
  "Ythanguul",
  "Ythenset",
  "Ythibik",
  "Zananshar",
  "Zanixrul",
  "Zanurresh",
  "Zorakdriel",
  "Zorishar",
  "Zorymshion",
  "Aurathix",
  "Bresthian",
  "Cathmorvax",
  "Dhurgaleth",
  "Erevathis",
  "Fyrrimant",
  "Ghorevith",
  "Hollaxian",
  "Iskarrion",
  "Jothrandil",
  "Kelzhadrin",
  "Lumirthos",
  "Morroghast",
  "Nyxandrel",
  "Ophirrian",
  "Pelthrazar",
  "Quessilax",
  "Ravathorn",
  "Sythrakal",
  "Thurmavax",
  "Uvandrix",
  "Vyrmathos",
  "Wyrmathiel",
  "Xyrrathon",
  "Yssimeth",
  "Zuldravan",
  "Adrakhaan",
  "Brontharis",
  "Corrumvash",
  "Dreskavaar",
  "Ennetharax",
  "Ghislavorn",
  "Haarnathul",
  "Ixxarion",
  "Jorrumvex",
  "Kethrandos",
  "Lothvarrin",
  "Mavrandil",
  "Nethraxis",
  "Ozzaridon",
  "Prythenaar",
  "Rimmandral",
  "Skavvorath",
  "Torrathiel",
  "Ulgrathax",
  "Vexxendor",
  "Wothrandir",
  "Xalvathir",
  "Yorrimand",
  "Zethraxian",
  "Scalewarden",
  "Hearthscale",
  "Wingwarden",
  "Flintscale",
  "Hornwarden",
  "Torrhavel"
 ]
}